// @ts-nocheck
import { Column } from 'react-table'
import { UserInfoCell } from './UserInfoCell'
import { UserLastLoginCell } from './UserLastLoginCell'
import { UserTwoStepsCell } from './UserTwoStepsCell'
import { UserActionsCell } from './UserActionsCell'
import { UserSelectionCell } from './UserSelectionCell'
import { UserCustomHeader } from './UserCustomHeader'
import { UserSelectionHeader } from './UserSelectionHeader'
import { User } from '../../core/_models'
import { UserLockedCell } from './UserLockedCell'

const usersColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => <UserSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ ...props }) => <UserSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Name' className=' min-w-125px ' />,
    id: 'first_name',
    Cell: ({ ...props }) => <UserInfoCell user={props.data[props.row.index]} />,
  },

  // {
  //   Header: (props) => <UserCustomHeader tableProps={props} title='Role' className='min-w-125px' />,
  //   accessor: 'role',
  // },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Status' className='min-w-125px ' />
    ),
    id: 'is_active',
    Cell: ({ ...props }) => <UserLastLoginCell last_login={props.data[props.row.index].is_active} />,
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Locked' className='min-w-125px' />
    ),
    id: 'is_locked',
    Cell: ({ ...props }) => <UserLockedCell is_locked={props.data[props.row.index].is_locked} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Notes' className='min-w-125px' />
    ),
    id: 'adminnotes',
    Cell: ({ ...props }) => <UserTwoStepsCell adminnotes={props.data[props.row.index].adminnotes} />,
  },

  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Joined day' className='min-w-125px' />
  //   ),
  //   accessor: 'joined_day',
  // },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px ' />
    ),
    id: 'actions',
    Cell: ({ ...props }) => {
      const id = props.data[props.row.index].id;
      return <UserActionsCell id={id} />;
    },
  },
]

export { usersColumns }
